const UrlService = {
  getNormalizedCurrentUrl(): string {
    if (typeof window === "undefined" || !window.location) {
      return "";
    }

    let pathname = window.location.pathname;
    if (pathname.endsWith("/")) {
      pathname = pathname.slice(0, -1);
    }
    const redirectUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      pathname +
      decodeURIComponent(window.location.search) +
      window.location.hash;

    return redirectUrl;
  },
};

export default UrlService;
